import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ProtectedRoute from "./utility/ProtectedRoute";


//e-neurons Dashboard
import EneuronLogin from './views/e-neuronsLogin';
import DashboardEneurons from './views/e-neuronsAdmin/Dashboard';
import HotelRegistration from './views/e-neuronsAdmin/create_hotel';

//hotel Admin
import LoginAdmin from './views/Hotel/Hotel-Admin/Login';
import AdminDashboard from './views/Hotel/Hotel-Admin/Dashboard';
import HotelRoomManagement from './views/Hotel/Hotel-Admin/HotelRoomManagement';
import StatisticsDashboard from './views/Hotel/Hotel-Admin/StatisticsDashboard';
import CustomerLoyaltyDashboard from './views/Hotel/Hotel-Admin/CustomerLoyaltyDashboard';
import AdminBookingDetails from './views/Hotel/Hotel-Admin/AdminBookingDetails';
import DiscountManagement from './views/Hotel/Hotel-Admin/DiscountManagement';
import HotelAdminFBMgmt from './views/Hotel/Hotel-Admin/HotelAdminFBMgmt';
import ResetPassword from './views/Hotel/Hotel-Admin/ResetPassword';
import FBCancelledOrdersReport from './views/Hotel/Hotel-Admin/FBCancelledOrdersReport';



//hotel staff
import LoginStaff from './views/Hotel/Hotel-Staff/Login';
import HotelStaffManagement from './views/Hotel/Hotel-Admin/staff/staff';
import HotelGuestBooking from './views/Hotel/Hotel-Staff/reception/booking';
import StaffDashboard from './views/Hotel/Hotel-Staff/reception/Dashboard';
import AccommodationSalesReport from './views/Hotel/Hotel-Staff/reception/AccommodationSalesReport';
import HotelGuestsManagement from './views/Hotel/Hotel-Staff/reception/HotelGuestsManagement';
import HotelFacilitiesManagement from './views/Hotel/Hotel-Staff/reception/HotelFacilitiesManagement';
import FacilityCreation from './views/Hotel/Hotel-Staff/reception/FacilityCreation';
import OtherIncomeManagement from './views/Hotel/Hotel-Staff/reception/OtherIncomeManagement';



import ChangePassword from './views/Hotel/Hotel-Staff/ChangePassword';
import ChangeAdminPassword from './views/Hotel/Hotel-Admin/ChangePassword';

import HotelFBMgmt from './views/Hotel/Hotel-Staff/F&B/HotelFBMgmt';
import FBAnalyticsDashboard from './views/Hotel/Hotel-Staff/F&B/FBAnalyticsDashboard';
import FBSalesReport from './views/Hotel/Hotel-Staff/F&B/FBSalesReport';
import FBBillingInvoices from './views/Hotel/Hotel-Staff/F&B/FBBillingInvoices';

//cashier
import CashierAnalyticsDashboard from './views/Hotel/Hotel-Staff/cashier/CashierAnalyticsDashboard';
import OrdersInvoicing from './views/Hotel/Hotel-Staff/cashier/OrdersInvoicing';
import CashierDailyReport from './views/Hotel/Hotel-Staff/cashier/CashierDailyReport';
import Cashier_OtherIncomeManagement from './views/Hotel/Hotel-Staff/cashier/Cashier_OtherIncomeManagement';



import HotelFBInventoryMgmt from './views/Hotel/Hotel-Staff/F&B/HotelFBInventoryMgmt';
import HotelFBTableManagement from './views/Hotel/Hotel-Staff/F&B/HotelFBTableManagement';


//hotel account
import CashierAccountDashboard from './views/Hotel/Hotel-Staff/account/Dashboard';
import Reportx from './views/Hotel/Hotel-Staff/account/Reportx';
import HotelBookingsDetails from './views/Hotel/Hotel-Staff/account/HotelBookingsDetails';
import InventoryAccounting from './views/Hotel/Hotel-Staff/account/InventoryAccounting';
import Acc_Approval from './views/Hotel/Hotel-Staff/storekeeping/Acc_Approval';
import ExpenseManagement from './views/Hotel/Hotel-Staff/account/ExpenseManagement';
import FinancialLedger from './views/Hotel/Hotel-Staff/account/FinancialLedger';
import SalaryDeductionApprovals from './views/Hotel/Hotel-Staff/account/SalaryDeductionApprovals';
import AccountantSalaryDashboard from './views/Hotel/Hotel-Staff/account/AccountantSalaryDashboard';
import PayrollGeneratorAccount from './views/Hotel/Hotel-Staff/account/PayrollGeneratorAccount';
import PurshaseOrdeAccountApproval from './views/Hotel/Hotel-Staff/account/PurshaseOrdeAccountApproval';



//hotel store keeper
import Storekeep_Dashboard from './views/Hotel/Hotel-Staff/storekeeping/Dashboard';
import ItemNamesManagement from './views/Hotel/Hotel-Staff/storekeeping/ItemNamesManagement';
import InventoryManagement from './views/Hotel/Hotel-Staff/storekeeping/InventoryManagement';
import StoreKeeperViewRequisition from './views/Hotel/Hotel-Staff/storekeeping/StoreKeeperViewRequisition';
import PurchaseRequests from './views/Hotel/Hotel-Staff/storekeeping/PurchaseRequests';


//Requisition
import Dashboard_requisition from './views/Hotel/Hotel-Staff/requisition_staff/Dashboard_requisition_staff';
import RequisitionManagement from './views/Hotel/Hotel-Staff/storekeeping/RequisitionManagement';

//HODs
import Dashboard_hod from './views/Hotel/Hotel-Staff/HOD/Dashboard_hod';
import HODRequisitionApproval from './views/Hotel/Hotel-Staff/HOD/HODRequisitionApproval';

//GM
import Dashboard_Gm from './views/Hotel/Hotel-Staff/GM/Dashboard_gm';
import GMInventoryDashboard from './views/Hotel/Hotel-Staff/GM/GMInventoryDashboard';
import GMRequisitionApproval from './views/Hotel/Hotel-Staff/GM/GMRequisitionApproval';
import Gm_StaffDashboard from './views/Hotel/Hotel-Staff/GM/Gm_StaffDashboard';
import PayrollGenerator from './views/Hotel/Hotel-Staff/GM/PayrollGenerator';
import PurshaseOrdeGMApproval from './views/Hotel/Hotel-Staff/GM/PurshaseOrdeGMApproval';


//HR
import Dashboard_hr from './views/Hotel/Hotel-Staff/HR/Dashboard';
import StaffInitialization from './views/Hotel/Hotel-Staff/HR/StaffInitialization';
import Onboard from './views/Hotel/Hotel-Staff/HR/onboard';
import Add_staff from './views/Hotel/Hotel-Staff/HR/add_staff';
import ProfileCheckerPhone from './views/Hotel/Hotel-Staff/HR/profileCheckerPhone';
import ProfileChecker from './views/Hotel/Hotel-Staff/HR/ProfileChecker';
import Dept from './views/Hotel/Hotel-Staff/HR/dept';
import StaffAppraisals from './views/Hotel/Hotel-Staff/HR/StaffAppraisals';
import QuarterlyReviews from './views/Hotel/Hotel-Staff/HR/QuarterlyReviews';
import HrLeaveDashboard from './views/Hotel/Hotel-Staff/HR/HrLeaveDashboard';
import Set_salary from './views/Hotel/Hotel-Staff/HR/set_salary';
import SalaryDeductions from './views/Hotel/Hotel-Staff/HR/SalaryDeductions';
import HrReportsDashboard from './views/Hotel/Hotel-Staff/HR/HrReportsDashboard';

import LeaveCalendar from './views/Hotel/Hotel-Staff/account/LeaveCalendar';
import LeaveCalendarCashier from './views/Hotel/Hotel-Staff/cashier/LeaveCalendar';
import LeaveCalendarFB from './views/Hotel/Hotel-Staff/F&B/LeaveCalendar';
import LeaveCalendarGM from './views/Hotel/Hotel-Staff/GM/LeaveCalendar';
import SalaryApprovals from './views/Hotel/Hotel-Staff/GM/SalaryApprovals';

import LeaveCalendarReception from './views/Hotel/Hotel-Staff/reception/LeaveCalendar';

//hotel website
import HotelWebsite from './views/Hotel/website/HotelWebsite';
import RoomDetails from './views/Hotel/website/RoomDetails';
import BookingPage from './views/Hotel/website/BookingPage';
import RoomsBooking from './views/Hotel/website/RoomsSuites';
import ContactPage from './views/Hotel/website/ContactPage';





import HospitalMessageCenter from './views/Hotel/Hotel-Admin/testPage';

function App() {
  return (
    <Router>
      <Routes>

 {/* This is hotel eneurons,hotel & staff  login route*/}
<Route path="/eneuronAdmin" element={<EneuronLogin />} />
 <Route path="/HotelAdmin" element={<LoginAdmin />} />
<Route path="/HotelStaff" element={<LoginStaff />} />


{/* This is eneurons route*/}
<Route path="/dashboard_e-neurons" element={<ProtectedRoute allowedRoles={["e-neurons"]}><DashboardEneurons /></ProtectedRoute>} />
<Route path="/register_hotel" element={<ProtectedRoute allowedRoles={["e-neurons"]}><HotelRegistration /></ProtectedRoute>} />
      
      
      
  {/* This is hotel Admin route*/}
 <Route path="/hotel/admin/dashboard" element={<ProtectedRoute allowedRoles={["hotel_admin"]}><AdminDashboard /></ProtectedRoute>} />
<Route path="/hotel/staff/record" element={<ProtectedRoute allowedRoles={["hotel_admin"]}><HotelStaffManagement /></ProtectedRoute>} />
<Route path="/hotel/rooms/management" element={<ProtectedRoute allowedRoles={["hotel_admin"]}><HotelRoomManagement /></ProtectedRoute>} />
<Route path="/hotel/admin/ChangePassword" element={<ProtectedRoute allowedRoles={["hotel_admin"]}><ChangeAdminPassword /></ProtectedRoute>} />
<Route path="/hotel/admin/StatisticsDashboard" element={<ProtectedRoute allowedRoles={["hotel_admin"]}><StatisticsDashboard /></ProtectedRoute>} />
<Route path="/hotel/admin/CustomerLoyaltyDashboard" element={<ProtectedRoute allowedRoles={["hotel_admin"]}><CustomerLoyaltyDashboard /></ProtectedRoute>} />
<Route path="/hotel/admin/AdminBookingDetails" element={<ProtectedRoute allowedRoles={["hotel_admin"]}><AdminBookingDetails /></ProtectedRoute>} />
<Route path="/hotel/admin/DiscountManagement" element={<ProtectedRoute allowedRoles={["hotel_admin"]}><DiscountManagement /></ProtectedRoute>} />
<Route path="/hotel/admin/HotelAdminFBMgmt" element={<ProtectedRoute allowedRoles={["hotel_admin"]}><HotelAdminFBMgmt /></ProtectedRoute>} />
<Route path="/hotel/admin/ResetPassword" element={<ProtectedRoute allowedRoles={["hotel_admin"]}><ResetPassword /></ProtectedRoute>} />
<Route path="/hotel/admin/FBCancelledOrdersReport" element={<ProtectedRoute allowedRoles={["hotel_admin"]}><FBCancelledOrdersReport /></ProtectedRoute>} />




 {/* This is hotel staff route*/}
 <Route path="/hotel/reception/dashboard" element={<ProtectedRoute allowedRoles={["receptionist"]}><StaffDashboard /></ProtectedRoute>} />
<Route path="/hotel/rooms/booking" element={<ProtectedRoute allowedRoles={["receptionist"]}><HotelGuestBooking /></ProtectedRoute>} />
<Route path="/hotel/rooms/AccommodationSalesReport" element={<ProtectedRoute allowedRoles={["receptionist"]}><AccommodationSalesReport /></ProtectedRoute>} />
<Route path="/hotel/rooms/HotelGuestsManagement" element={<ProtectedRoute allowedRoles={["receptionist", "hotel_admin"]}><HotelGuestsManagement /></ProtectedRoute>} />
<Route path="/hotel/rooms/HotelFacilitiesManagement" element={<ProtectedRoute allowedRoles={["receptionist"]}><HotelFacilitiesManagement /></ProtectedRoute>} />
<Route path="/hotel/rooms/FacilityCreation" element={<ProtectedRoute allowedRoles={["hotel_admin"]}><FacilityCreation /></ProtectedRoute>} />
<Route path="/hotel/rooms/OtherIncomeManagement" element={<ProtectedRoute allowedRoles={["receptionist"]}><OtherIncomeManagement /></ProtectedRoute>} />
<Route path="/hotel/HR/LeaveCalendarReception" element={<ProtectedRoute allowedRoles={["receptionist",]}><LeaveCalendarReception/></ProtectedRoute>} />


<Route path="/hotel/staff/ChangePassword" element={<ProtectedRoute allowedRoles={["receptionist"]}><ChangePassword /></ProtectedRoute>} />

<Route path="/hotel/fb/management" element={<ProtectedRoute allowedRoles={["Restaurant/Bar"]}><HotelFBMgmt /></ProtectedRoute>} />
<Route path="/hotel/fb/dashboard" element={<ProtectedRoute allowedRoles={["Restaurant/Bar"]}><FBAnalyticsDashboard /></ProtectedRoute>} />
<Route path="/hotel/fb/FBSalesReport" element={<ProtectedRoute allowedRoles={["Restaurant/Bar"]}><FBSalesReport /></ProtectedRoute>} />
<Route path="/hotel/fb/FBBillingInvoices" element={<ProtectedRoute allowedRoles={["Restaurant/Bar"]}><FBBillingInvoices /></ProtectedRoute>} />
<Route path="/hotel/fb/HotelFBInventoryMgmt" element={<ProtectedRoute allowedRoles={["hotel_admin"]}><HotelFBInventoryMgmt /></ProtectedRoute>} />
<Route path="/hotel/fb/HotelFBTableManagement" element={<ProtectedRoute allowedRoles={["hotel_admin"]}><HotelFBTableManagement /></ProtectedRoute>} />
<Route path="/hotel/HR/LeaveCalendarFB" element={<ProtectedRoute allowedRoles={["Restaurant/Bar",]}><LeaveCalendarFB/></ProtectedRoute>} />


{/* This is hotel cashier route*/}
<Route path="/hotel/cashier/dashboard" element={<ProtectedRoute allowedRoles={["Cashier"]}><CashierAnalyticsDashboard /></ProtectedRoute>} />
<Route path="/hotel/cashier/ordersInvoicing" element={<ProtectedRoute allowedRoles={["Cashier"]}><OrdersInvoicing /></ProtectedRoute>} />
<Route path="/hotel/cashier/CashierDailyReport" element={<ProtectedRoute allowedRoles={["Cashier"]}><CashierDailyReport /></ProtectedRoute>} />
<Route path="/hotel/HR/LeaveCalendarCashier" element={<ProtectedRoute allowedRoles={["Cashier",]}><LeaveCalendarCashier/></ProtectedRoute>} />
<Route path="/hotel/HR/Cashier_OtherIncomeManagement" element={<ProtectedRoute allowedRoles={["Cashier",]}><Cashier_OtherIncomeManagement/></ProtectedRoute>} />



<Route path="/hotel/Acc/Dashboard" element={<ProtectedRoute allowedRoles={["Account"]}><CashierAccountDashboard/></ProtectedRoute>} />
<Route path="/hotel/Cashier_Acc/report" element={<ProtectedRoute allowedRoles={["Account",]}><Reportx /></ProtectedRoute>} />
<Route path="/hotel/Cashier_Acc/HotelBookingsDetails" element={<ProtectedRoute allowedRoles={["Account",]}><HotelBookingsDetails /></ProtectedRoute>} />
<Route path="/hotel/Acc/InventoryAccounting" element={<ProtectedRoute allowedRoles={["Account",]}><InventoryAccounting /></ProtectedRoute>} />
<Route path="/hotel/Acc/Acc_Approval" element={<ProtectedRoute allowedRoles={["Account",]}><Acc_Approval /></ProtectedRoute>} />
<Route path="/hotel/Acc/ExpenseManagement" element={<ProtectedRoute allowedRoles={["Account",]}><ExpenseManagement /></ProtectedRoute>} />
<Route path="/hotel/Acc/FinancialLedger" element={<ProtectedRoute allowedRoles={["Account",]}><FinancialLedger /></ProtectedRoute>} />
<Route path="/hotel/Acc/SalaryDeductionApprovals" element={<ProtectedRoute allowedRoles={["Account",]}><SalaryDeductionApprovals /></ProtectedRoute>} />
<Route path="/hotel/Acc/LeaveCalendar" element={<ProtectedRoute allowedRoles={["Account",]}><LeaveCalendar/></ProtectedRoute>} />
<Route path="/hotel/Acc/AccountantSalaryDashboard" element={<ProtectedRoute allowedRoles={["Account",]}><AccountantSalaryDashboard/></ProtectedRoute>} />
<Route path="/hotel/Acc/PayrollGeneratorAccount" element={<ProtectedRoute allowedRoles={["Account",]}><PayrollGeneratorAccount/></ProtectedRoute>} />
<Route path="/hotel/Acc/PurshaseOrdeAccountApproval" element={<ProtectedRoute allowedRoles={["Account",]}><PurshaseOrdeAccountApproval/></ProtectedRoute>} />



<Route path="/hotel/Storekeeping/Dashboard" element={<ProtectedRoute allowedRoles={["Storekeeping",]}><Storekeep_Dashboard /></ProtectedRoute>} />
<Route path="/hotel/Storekeeping/ItemNamesManagement" element={<ProtectedRoute allowedRoles={["Storekeeping",]}><ItemNamesManagement /></ProtectedRoute>} />
<Route path="/hotel/Storekeeping/InventoryManagement" element={<ProtectedRoute allowedRoles={["Storekeeping",]}><InventoryManagement /></ProtectedRoute>} />
<Route path="/hotel/Storekeeping/StoreKeeperViewRequisition" element={<ProtectedRoute allowedRoles={["Storekeeping",]}><StoreKeeperViewRequisition /></ProtectedRoute>} />
<Route path="/hotel/Storekeeping/PurchaseRequests" element={<ProtectedRoute allowedRoles={["Storekeeping",]}><PurchaseRequests /></ProtectedRoute>} />



<Route path="/hotel/requisition/Dashboard_requisition" element={<ProtectedRoute allowedRoles={["Requisition",]}><Dashboard_requisition /></ProtectedRoute>} />
<Route path="/hotel/requisition/RequisitionManagement" element={<ProtectedRoute allowedRoles={["Requisition",]}><RequisitionManagement /></ProtectedRoute>} />


<Route path="/hotel/hod/Dashboard_hod" element={<ProtectedRoute allowedRoles={["hod",]}><Dashboard_hod/></ProtectedRoute>} />
<Route path="/hotel/hod/HODRequisitionApproval" element={<ProtectedRoute allowedRoles={["hod",]}><HODRequisitionApproval/></ProtectedRoute>} />

<Route path="/hotel/GM/Dashboard_Gm" element={<ProtectedRoute allowedRoles={["General_Manager",]}><Dashboard_Gm/></ProtectedRoute>} />
<Route path="/hotel/GM/GMInventoryDashboard" element={<ProtectedRoute allowedRoles={["General_Manager",]}><GMInventoryDashboard/></ProtectedRoute>} />
<Route path="/hotel/GM/GMRequisitionApproval" element={<ProtectedRoute allowedRoles={["General_Manager",]}><GMRequisitionApproval/></ProtectedRoute>} />
<Route path="/hotel/GM/Gm_StaffDashboard" element={<ProtectedRoute allowedRoles={["General_Manager",]}><Gm_StaffDashboard/></ProtectedRoute>} />
<Route path="/hotel/GM/PayrollGenerator" element={<ProtectedRoute allowedRoles={["General_Manager",]}><PayrollGenerator/></ProtectedRoute>} />
<Route path="/hotel/GM/PurshaseOrdeGMApproval" element={<ProtectedRoute allowedRoles={["General_Manager",]}><PurshaseOrdeGMApproval/></ProtectedRoute>} />



<Route path="/hotel/GM/LeaveCalendarGM" element={<ProtectedRoute allowedRoles={["General_Manager",]}><LeaveCalendarGM/></ProtectedRoute>} />
<Route path="/hotel/GM/SalaryApprovals" element={<ProtectedRoute allowedRoles={["General_Manager",]}><SalaryApprovals/></ProtectedRoute>} />


{/* This is HR Route*/}
<Route path="/hotel/HR/Dashboard_hr" element={<ProtectedRoute allowedRoles={["hr",]}><Dashboard_hr/></ProtectedRoute>} />
<Route path="/hotel/HR/StaffInitialization" element={<ProtectedRoute allowedRoles={["hr",]}><StaffInitialization/></ProtectedRoute>} />
<Route path="/hotel/HR/Onboard" element={<ProtectedRoute allowedRoles={["hr",]}><Onboard/></ProtectedRoute>} />
<Route path="/hotel/HR/add_staff" element={<ProtectedRoute allowedRoles={["hr",]}><Add_staff/></ProtectedRoute>} />
<Route path="/hotel/HR/ProfileCheckerPhone" element={<ProtectedRoute allowedRoles={["hr",]}><ProfileCheckerPhone/></ProtectedRoute>} />
<Route path="/hotel/HR/ProfileChecker" element={<ProtectedRoute allowedRoles={["hr",]}><ProfileChecker/></ProtectedRoute>} />
<Route path="/hotel/HR/Dept" element={<ProtectedRoute allowedRoles={["hr",]}><Dept/></ProtectedRoute>} />
<Route path="/hotel/HR/StaffAppraisals" element={<ProtectedRoute allowedRoles={["hr",]}><StaffAppraisals/></ProtectedRoute>} />
<Route path="/hotel/HR/QuarterlyReviews" element={<ProtectedRoute allowedRoles={["hr",]}><QuarterlyReviews/></ProtectedRoute>} />
<Route path="/hotel/HR/HrLeaveDashboard" element={<ProtectedRoute allowedRoles={["hr",]}><HrLeaveDashboard/></ProtectedRoute>} />
<Route path="/hotel/HR/Set_salary" element={<ProtectedRoute allowedRoles={["hr",]}><Set_salary/></ProtectedRoute>} />
<Route path="/hotel/HR/SalaryDeductions" element={<ProtectedRoute allowedRoles={["hr",]}><SalaryDeductions/></ProtectedRoute>} />
<Route path="/hotel/HR/HrReportsDashboard" element={<ProtectedRoute allowedRoles={["hr",]}><HrReportsDashboard/></ProtectedRoute>} />


{/* This is hotel website route*/}
<Route path="/" element={<LoginStaff />} />
<Route path="/room/:id" element={<RoomDetails />} />
<Route path="/booking" element={<BookingPage />} />
<Route path="/RoomsSuites" element={<RoomsBooking />} />
<Route path="/ContactPage" element={<ContactPage />} />

<Route path="/test" element={<HospitalMessageCenter />} />
       </Routes>
    </Router>
  );
}

export default App;
